import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardMedia,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import FireExitIcon from '../../../assets/images/icons/ico_intro_fire-exit.svg'
import SensorIcon from '../../../assets/images/icons/ico_intro_sensor.svg'
import LeakIcon from '../../../assets/images/icons/ico_intro_water.svg'
import AirQualityIcon from '../../../assets/images/icons/ico_intro_o2.svg'

class TutorialStep1 extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    root: theme.introCardRoot,
    media: theme.introCardMedia,
    content: theme.introCardContent,
    mediaContainer: {
      height: '100%',
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Card square elevation={3} classes={{ root: classes.root }}>
        <CardMedia className={classes.media}>
          <Grid container direction="row" justify="space-evenly" alignItems="center" className={classes.mediaContainer}>
            <Grid item><img src={FireExitIcon} alt="fire exit icon" /></Grid>
            <Grid item><img src={SensorIcon} alt="sensor icon" /></Grid>
            <Grid item><img src={LeakIcon} alt="leak icon" /></Grid>
            <Grid item><img src={AirQualityIcon} alt="air quality icon" /></Grid>
          </Grid>
        </CardMedia>
        <CardContent className={classes.content}>
          <Typography variant="h1">
            What data do we collect and why
          </Typography>
          <Typography variant="h2">
            Sensors, alerts, and reports to help you quickly identify and respond to safety and
            performance issues in your comunity.
          </Typography>
          <p>
            Blokable homes come pre-wired and configured with sensors that collect important safety,
            performance, and environmental data.
          </p>
          <ul>
            <li>Safety - Smoke, carbon monoxide, sprinkler activity, leaks, door security</li>
            <li>Performance - power & water usage, humidity, temperature, hub status</li>
            <li>Environmental - air quality</li>
          </ul>
        </CardContent>
      </Card>
    )
  }
}

export default withStyles(TutorialStep1.styles)(TutorialStep1)
